import Commons from '../../../../Services/Common/Common';

/**
 * HAM_BASIC_02 스키마
 * - fields: 폼/그리드에서 공통으로 쓰는 필드 정의
 *   - initial: 초기값
 *   - label: 필드명
 *   - required: 필수 입력 여부
 *
 * - mapper: 저장/삭제 API payload 생성 규칙
 *   - mapRowsBySchema(rows, mapper, context)로 payload를 만듬
 *   - context에는 userInfo 등이 들어오며(mapRowsBySchema에 기본족으로 정의되어 있음),
 *     화면에서 추가로 필요한 값(custCd 등)을 context로 넘겨줄 수 있다.
 */
export const HAM_BASIC_02_Schema = {
  fields: {
    // Master 필드
    master: {
      no: { initial: '', label: 'NO' },
      hbmId: { initial: '', label: 'HBM_ID' },
      productName: { initial: '', label: '제품명', required: 'Y' },
      processType: { initial: '', label: '취급공종', required: 'Y' },
      workerName: { initial: '', label: '작업자명' },
      firstExamMonths: { initial: '', label: '최초진단 개월' },
      examCycleMonths: { initial: '', label: '특수건강진단 주기 (개월)', required: 'Y' },
      distributionContact: { initial: '', label: '배포처/연락처', required: 'Y' },
      warningLabelFileName: { initial: '', label: '경고표지 첨부', required: 'Y' },
      warningLabelFilePath: { initial: '', label: '경고표지 경로' },
      remark: { initial: '', label: '비고' },
    },
    // Detail 필드
    detail: {
      hbdId: { initial: '', label: 'HBD_ID' },
      substanceName: { initial: '', label: '물질명', required: 'Y' },
      casNo: { initial: '', label: 'CAS NO.', required: 'Y' },
      contentPercent: { initial: '', label: '함유율' },
      managementTarget: { initial: 'N', label: '관리대상' },
      specialManagement: { initial: 'N', label: '특별관리' },
      workEnvMeasurement: { initial: 'N', label: '작업환경측정' },
      specialHealthExam: { initial: 'N', label: '특수건강진단' },
      permissionTarget: { initial: 'N', label: '허가대상' },
    },
  },

  mapper: {
    search1: {
      CustCd: (_, context) =>
        Commons.EncryptAES(context.search?.custCd || '') || '',
    },
    delete1: {
      HbmId: (row) =>
        Commons.EncryptAES(row.hbmId ? row.hbmId.toString() : '0') || '',
    },
    delete2: {
      HbdId: (row) =>
        Commons.EncryptAES(row.hbdId ? row.hbdId.toString() : '0') || '',
    },
    save1: {
      HbmId: (row) => {
        const hbmId = row.hbmId;
        const hbmIdValue =
          hbmId && hbmId.toString().trim() !== '' ? hbmId.toString() : '0';
        return Commons.EncryptAES(hbmIdValue) || '';
      },
      CustCd: (_, context) =>
        Commons.EncryptAES(context.search?.custCd || '') || '',
      ProcessType: (row) => Commons.EncryptAES(row.processType || '') || '',
      WorkerName: (row) => Commons.EncryptAES(row.workerName || '') || '',
      ProductName: (row) => Commons.EncryptAES(row.productName || '') || '',
      FirstExamMonths: (row) =>
        Commons.EncryptAES(
          row.firstExamMonths ? row.firstExamMonths.toString() : '0'
        ) || '',
      ExamCycleMonths: (row) =>
        Commons.EncryptAES(
          row.examCycleMonths ? row.examCycleMonths.toString() : '0'
        ) || '',
      DistributionContact: (row) =>
        Commons.EncryptAES(row.distributionContact || '') || '',
      WarningLabelFileName: (row) =>
        Commons.EncryptAES(row.warningLabelFileName || '') || '',
      WarningLabelFilePath: (row, context) => {
        // 새 파일 업로드 시: previewFilePath에서 saveName 추출하여 최종 경로 생성
        const previewPath = row.previewFilePath || '';
        if (previewPath) {
          const saveName = previewPath.split('/').pop() || '';
          const finalPath = `HazardousMaterials/${context.search?.custCd}/HAM_BASIC_03/${saveName}`;
          return Commons.EncryptAES(finalPath) || '';
        }

        // 기존 파일 유지 시: warningLabelFilePath 직접 사용
        const existingFilePath = row.warningLabelFilePath || '';
        if (!existingFilePath) return '';
        return Commons.EncryptAES(existingFilePath) || '';
      },
      Remark: (row) => Commons.EncryptAES(row.remark || '') || '',
      UserId: (_, context) => context.userInfo?.userid || '',
    },
    save2: {
      HbdId: (row) => {
        const hbdId = row.hbdId;
        const hbdIdValue =
          hbdId && hbdId.toString().trim() !== '' ? hbdId.toString() : '0';
        return Commons.EncryptAES(hbdIdValue) || '';
      },
      HbmId: (row) =>
        Commons.EncryptAES(row.hbmId ? row.hbmId.toString() : '0') || '',
      SubstanceName: (row) => Commons.EncryptAES(row.substanceName || '') || '',
      CasNo: (row) => Commons.EncryptAES(row.casNo || '') || '',
      ContentPercent: (row) =>
        Commons.EncryptAES(row.contentPercent || '') || '',
      ManagementTarget: (row) =>
        Commons.EncryptAES(row.managementTarget || '') || '',
      SpecialManagement: (row) =>
        Commons.EncryptAES(row.specialManagement || '') || '',
      WorkEnvMeasurement: (row) =>
        Commons.EncryptAES(row.workEnvMeasurement || '') || '',
      SpecialHealthExam: (row) =>
        Commons.EncryptAES(row.specialHealthExam || '') || '',
      PermissionTarget: (row) =>
        Commons.EncryptAES(row.permissionTarget || '') || '',
      UserId: (_, context) => context.userInfo?.userid || '',
    },
  },
};
